import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteRate } from 'api/wage/deleteRate'
import { wageRuleKeys } from './keys'

export const useDeleteRateMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof deleteRate>[0]) =>
      deleteRate(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
